/**
 * Sign out by clearing localStorage and redirecting to signin.
 * Does not update Zustand stores, so the current page never re-renders
 * with "logged out" state — avoiding UI blink before redirect.
 */
export function signOut(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('userId');
  localStorage.removeItem('email');
  localStorage.removeItem('user');
  // Clear persisted store state so next load starts fresh
  localStorage.removeItem('user-storage');
  localStorage.removeItem('two-factor-storage');
  window.location.replace('/signin');
}
